import { render, staticRenderFns } from "./serverList.vue?vue&type=template&id=1dfe8962&scoped=true"
import script from "./serverList.vue?vue&type=script&lang=js"
export * from "./serverList.vue?vue&type=script&lang=js"
import style0 from "./serverList.vue?vue&type=style&index=0&id=1dfe8962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfe8962",
  null
  
)

export default component.exports